<script setup>
defineEmits(['click'])
</script>

<template>
  <div
    class="pa-2 position-fixed bottom-0 w-100"
    style="max-width: 450px; z-index: 20"
  >
    <div class="py-3 px-4 bg-orange rounded-xl d-flex justify-center align-center ga-2">
      <v-icon
        icon="mdi-alert-circle"
        size="28"
      />
      <div>
        {{ $t('general_interface.filter.outdated') }}
      </div>
      <div>
        <v-btn
          variant="outlined"
          @click="
            () => {
              $emit('click')
            }
          "
        >
          {{ $t('general_interface.buttons.reload') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
